import { Menu, MenuItem, makeStyles } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import MORE_OPTIONS from '../../../assets/images/Icon/dotIcon.svg';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
import { EditIcon, TrashIcon } from '../Images/Icons';
import comparisonIcon from '../../../assets/images/Icon/comparisonIcon.PNG';
import editNameIcon from '../../../assets/images/Icon/editNameIcon.svg';
import MessagesContext from '../../../contexts/messagesContext';
import dotIcon from '../../../assets/images/logo/optionIconBlue.svg';

const styles = makeStyles({
    optionIconContainer: (props) => ({
        position: 'absolute',
        top: props.top ? props.top + 'px' : 'auto',
        bottom: props.bottom ? props.bottom + 'px' : 'auto',
        left: props.left ? props.left + 'px' : 'auto',
        right: props.right ? props.right + 'px' : 'auto'
    }),
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)'
    },
    paper: {
        border: 'solid 1px #e8ecf2',
        borderRadius: '8px'
    },
    moreOptionIcon: ({ disabled }) => ({
        width: '18px',
        height: '18px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? '0.5' : 1
    }),
    innerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.07',
        letterSpacing: 'normal',
        color: '#232733'
    },
    icon: {
        marginInlineStart: '7px'
    },
    menuItemGutters: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        // paddingLeft: '10px',
        // paddingRight: '10px'
        // padding: "10px",
        padding: '10px 10px 10px 50px',

        background: '#fff !important',
        '&:hover': {
            background: '#c0c0c0'
        }
    },
    sizeIcon: {
        width: '20px',
        height: '20px'
    },
    optionWrapper: ({ showIcon }) => ({
        borderRadius: '4px',
        boxShadow: '0 2px 4px 0 rgba(84, 94, 102, 0.12)',
        padding: '2px 3px 2px 6px',
        color: '#416ce1',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        visibility: showIcon ? 'visible' : 'hidden',
        background: '#fff'
    }),
    optionTitle: {
        fontSize: '13px',
        color: '#416ce1',
        fontFamily: 'inherit',
        fontWeight: 'bold'
    }
});
const Options = ({ options, showIcon, isSetting, disabled = false, ...props }) => {
    const { lang } = useContext(LanguageContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = styles({
        ...props,
        rtl: lang === 'fa',
        showIcon: !anchorEl && showIcon,
        disabled
    });
    const { messages } = useContext(MessagesContext);
    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };
    const toggleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleSelect = (event, option) => {
        event.stopPropagation();
        handleClose(event);
        props.handleClose && props.handleClose(event);
        props.handleSelect(option);
    };
    const renderIcon = (icon) => {
        if (icon === 'edit') {
            return (
                <EditIcon className={classes.icon} width={'20px'} height={'20px'} color={'black'} />
            );
        } else if (icon === 'delete') {
            return <TrashIcon className={classes.icon} width={'20px'} height={'20px'} />;
        } else if (icon === 'comparison') {
            return (
                <img
                    className={`${classes.icon} ${classes.sizeIcon}`}
                    src={comparisonIcon}
                    alt="comparison"
                />
            );
        } else if (icon === 'editName') {
            return (
                <img
                    className={`${classes.icon} ${classes.sizeIcon}`}
                    src={editNameIcon}
                    alt="editName"
                />
            );
        }
    };
    return (
        <>
            <div
                className={classes.optionIconContainer}
                onClick={(event) => !disabled && toggleMenu(event)}
                data-testid="moreIcon"
            >
                {isSetting ? (
                    <div className={classes.optionWrapper}>
                        <img src={dotIcon} alt="..." />
                        <span className={classes.optionTitle}>{messages.options}</span>
                    </div>
                ) : (
                    <img
                        className={classes.moreOptionIcon}
                        width={props.width || '20px'}
                        height={props.width || '20px'}
                        src={MORE_OPTIONS}
                        alt="more"
                    />
                )}
            </div>
            <Menu
                classes={{ list: classes.wrapper, paper: classes.paper }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={(e) => {
                    handleClose(e);
                    props.handleClose && props.handleClose();
                }}
                data-testid="menu"
            >
                {options.map((option, key) => (
                    <MenuItem
                        classes={{ gutters: classes.menuItemGutters }}
                        onClick={(e) => handleSelect(e, option)}
                        key={key}
                        value={option.value}
                    >
                        <div className={classes.innerContainer}>
                            <span>{option.label}</span>
                            {option.icon && <div>{renderIcon(option.icon)}</div>}
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
Options.propTypes = {
    options: PropTypes.array,
    handleSelect: PropTypes.func,
    handleClose: PropTypes.func,
    width: PropTypes.number,
    showIcon: PropTypes.bool,
    isSetting: PropTypes.bool,
    disabled: PropTypes.bool
};
export default Options;
